import { Component } from '@angular/core';
import { FeedbackPlatformParticipantEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Participants') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformparticipant-form',
    templateUrl: './feedbackplatformparticipant.form.component.html'
})
export class FeedbackPlatformParticipantFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformParticipantEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

